// src/services/authService
import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from './getBaseQuery';
import { DeleteChartRequest, DeleteChartResponse, GetChartByWellRequest, GetChartByWellResponse, GetChartRequest, GetChartResponse, GetChartUuidRequest, GetChartUuidResponse, PatchChartRequest, PatchChartResponse, PostChartRequest, PostChartResponse, PutChartRequest, PutChartResponse, UploadExcelResponse } from './types/TChartServices';

const URL_Prefix = '/chart';

export const chartService = createApi({
    reducerPath: 'chartService',
    baseQuery: getBaseQuery,
    tagTypes: ['Chart'],
    endpoints: (builder) => ({
        uploadExcel: builder.mutation<UploadExcelResponse, FormData>({
            query: (formData) => {
                const formattedFormData = new FormData();

                formData.forEach((value, key) => {
            formattedFormData.append(key, value);
        });

                return {
                    url: `${URL_Prefix}/upload_excel/`,
                    method: 'POST',
                    body: formattedFormData,
                };
            },
        }),
        updateChart: builder.mutation<PatchChartResponse, PatchChartRequest>({
            query: (chartData) => ({
                url: `${URL_Prefix}/${chartData.uuid}/`,
                method: 'PATCH',
                body: chartData,
            }),
            invalidatesTags: ['Chart'],
        }),
        getChart: builder.query<GetChartResponse[], GetChartRequest>({
            query: (chartData) => ({
                url: `${URL_Prefix}/`,
                method: 'GET',
                body: chartData,
            }),
        }),
        postChart: builder.mutation<PostChartResponse, PostChartRequest>({
            query: () => ({
                url: `${URL_Prefix}/`,
                method: 'POST',
            }),
            invalidatesTags: ['Chart'],
        }),
        getChartUuid: builder.query<GetChartUuidResponse, GetChartUuidRequest>({
            query: (chartData) => ({
                url: `${URL_Prefix}/${chartData.uuid}/`,
                method: 'GET',
            }),
        }),
        putChart: builder.mutation<PutChartResponse, PutChartRequest>({
            query: (chartData) => ({
                url: `${URL_Prefix}/${chartData.uuid}/`,
                method: 'PUT',
                body: chartData,
            }),
            invalidatesTags: ['Chart'],
        }),
        deleteTable: builder.mutation<DeleteChartResponse, DeleteChartRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/${body.uuid}/`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Chart'],
        }),
        getChartByWell: builder.query<GetChartByWellResponse, GetChartByWellRequest>({
            query: (chartData) => ({
                url: `${URL_Prefix}/by_well/${chartData.well_uuid}/`,
                method: 'GET',
            }),
        }),
    }),
});

// Экспортируем все хуки, включая useLazySendCodeQuery
export const {
    useUploadExcelMutation,
    useUpdateChartMutation,
    useDeleteTableMutation,
    useGetChartByWellQuery,
    useGetChartQuery,
    useGetChartUuidQuery,
    useLazyGetChartByWellQuery,
    useLazyGetChartQuery,
    useLazyGetChartUuidQuery,
    usePostChartMutation,
    usePutChartMutation,
} = chartService;